import React, { Component } from "react";
import { Provider } from "react-redux";
import store from "./store/index";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";
import { Route, Switch, Redirect } from "react-router-dom";
import Stepper from "./components/organisms/Stepper/index";
import Dashboard from "./components/pages/Dashboard";
import RegistrationFormPage from "./components/pages/RegistrationFormPage";
import Admin from "./components/pages/Admin";
import PrivateRoute from "./container/auth";
import Login from "./container/login";
import PageLayout from "./layout";
import EmailVerification from "./components/pages/Error/EmailVerification";
import ErrorAuthentication from "./components/pages/Error/AuthenticationFailed";
import SignOutThankYou from "./components/pages/SignOutThankYou";
import AffiliatePage from "./components/pages/AffiliatePage";
import "./css/bodyFix.css";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <PageLayout>
            <Switch>
              {/* <Route path="/whitelisting" component={Stepper} /> */}
              <Route path="/order" component={Stepper} />
              <PrivateRoute
                path="/dashboard/user/edit"
                component={RegistrationFormPage}
              />
              <PrivateRoute path="/dashboard" component={Dashboard} />
              <PrivateRoute path="/icoadmin" component={Admin} />
              <Route path="/signout-thankyou" component={SignOutThankYou} />
              <Route
                path="/error/emailverification"
                component={EmailVerification}
              />
              <Route
                path="/error/authentication"
                component={ErrorAuthentication}
              />
              <Route path="/login" component={Login} />
              <Route path="/affiliate" component={AffiliatePage} />
              {/* <Route component={Stepper} /> */}
              <Redirect from="/" to="/order"/>
            </Switch>
          </PageLayout>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;
